document.addEventListener("DOMContentLoaded", function () {
    const formElement = document.getElementById("SearchFiltersForm");
    const clearButton = document.querySelector(".clear-all-filters");

    if (!formElement) {
        console.error("Filter form element not found.");
        return;
    }

    // Collect selected filter values and allow multiple selections in each category
    function getSelectedFilters() {
        const params = new URLSearchParams();

        // Keep essential search parameters
        params.set("q", window.location.search.match(/q=([^&]*)/)?.[1] || ""); // Retain search term
        params.set("type", "product");
        params.set("options[prefix]", "last");

        // Add checked filters to the params
        formElement.querySelectorAll("input[type='checkbox']:checked").forEach(input => {
            params.append(input.name, input.value); // Allow multiple values for same filter
        });

        return params.toString();
    }

    // Fetch and update product grid based on selected filters
    function renderFilteredResults(queryString) {
        const url = `${window.location.pathname}?${queryString}`;

        document.body.classList.add("has-halo-loader"); // Show overlay

        fetch(url)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newContent = doc.getElementById("CollectionProductGrid");
                const currentContent = document.getElementById("CollectionProductGrid");

                if (newContent && currentContent) {
                    currentContent.innerHTML = newContent.innerHTML;
                } else {
                    console.error("Unable to update collection grid.");
                }
            })
            .catch(error => console.error("Error fetching filtered results:", error))
            .finally(() => {
                document.body.classList.remove("has-halo-loader"); // Hide overlay once done
            });
    }

    // Clear all filters and reset the page to the default search query
    if (clearButton) {
        clearButton.addEventListener("click", () => {
            // Uncheck all checkboxes
            formElement.querySelectorAll("input[type='checkbox']").forEach(input => {
                input.checked = false;
            });

            // Create a URLSearchParams with only essential parameters
            const params = new URLSearchParams();
            params.set("q", window.location.search.match(/q=([^&]*)/)?.[1] || ""); // Keep the search term
            params.set("type", "product");

            const queryString = params.toString();
            history.pushState({}, '', `${window.location.pathname}?${queryString}`);
            
            // Reload results with the default search query
            renderFilteredResults(queryString);
        });
    }

    // Update the page on filter change
    formElement.addEventListener("change", () => {
        const queryString = getSelectedFilters();
        history.pushState({}, '', `${window.location.pathname}?${queryString}`);
        renderFilteredResults(queryString);
    });
});
